module.exports = __webpack_public_path__ + "img/back_23.7e70f483.svg";